module.exports = __webpack_public_path__ + "static/media/appointmentError.20368505.svg";